/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Select_Folder_TitleInputs */

const en_options_backup_select_folder_title = /** @type {(inputs: Options_Backup_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic Backup - Select Folder`)
};

const fr_options_backup_select_folder_title = /** @type {(inputs: Options_Backup_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sauvegarde automatique - Sélectionner un dossier`)
};

const de_options_backup_select_folder_title = /** @type {(inputs: Options_Backup_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Datensicherung – Ordner auswählen`)
};

const it_options_backup_select_folder_title = /** @type {(inputs: Options_Backup_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backup automatico - Seleziona cartella`)
};

const ru_options_backup_select_folder_title = /** @type {(inputs: Options_Backup_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическое резервное копирование — выберите папку`)
};

const es_options_backup_select_folder_title = /** @type {(inputs: Options_Backup_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia de seguridad automática: seleccionar carpeta`)
};

const zh_cn2_options_backup_select_folder_title = /** @type {(inputs: Options_Backup_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动备份 - 选择文件夹`)
};

const ja_options_backup_select_folder_title = /** @type {(inputs: Options_Backup_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動バックアップ - フォルダを選択`)
};

const hi_options_backup_select_folder_title = /** @type {(inputs: Options_Backup_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित बैकअप - फ़ोल्डर चुनें`)
};

const pt_pt2_options_backup_select_folder_title = /** @type {(inputs: Options_Backup_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cópia de segurança automática - Selecionar pasta`)
};

/**
* | output |
* | --- |
* | "Automatic Backup - Select Folder" |
*
* @param {Options_Backup_Select_Folder_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_select_folder_title = /** @type {((inputs?: Options_Backup_Select_Folder_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Select_Folder_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_backup_select_folder_title(inputs)
	if (locale === "de") return de_options_backup_select_folder_title(inputs)
	if (locale === "it") return it_options_backup_select_folder_title(inputs)
	if (locale === "ru") return ru_options_backup_select_folder_title(inputs)
	if (locale === "es") return es_options_backup_select_folder_title(inputs)
	if (locale === "zh-CN") return zh_cn2_options_backup_select_folder_title(inputs)
	if (locale === "ja") return ja_options_backup_select_folder_title(inputs)
	if (locale === "hi") return hi_options_backup_select_folder_title(inputs)
	if (locale === "pt-PT") return pt_pt2_options_backup_select_folder_title(inputs)
	return en_options_backup_select_folder_title(inputs)
});